import { getColor, renderIcon } from '../../utils'

const generateStyles = ({ color, style }) => {
  if (color) {
    return {
      ...style,
      color: getColor(color) || getColor('n6'),
      fill: getColor(color) || getColor('n6'),
    }
  }
  return {
    ...style,
  }
}

const generateIconOptions = (color, style) => ({
  height: style.height || 14,
  width: style.width || 14,
  style: generateStyles({ color, style }),
  key: 'icon',
  ariaMode: 'hidden',
})

export const iconRenderer = (icon, color, style) => {
  const options = generateIconOptions(color, style)
  if (icon.includes('gem-')) options.system = 'gem'
  return renderIcon(icon, options)
}
